import React from "react";
import AppVersion from "../Settings/AppVersion";
import styles from "./AppUpdate.module.css";

const AppUpdate: React.FC = () => {
  return (
    <div className={styles.pageContainer}>
      <div className={styles.heroCard}>
        <div className={styles.heroContent}>
          <h2 className={styles.title}>App Update</h2>
         
        </div>
      </div>
      <div className={styles.formPanel}>
        <AppVersion />
      </div>
    </div>
  );
};

export default AppUpdate;